import { List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Link } from "react-router-dom";
import LocalStorageProvider from "../../../utils/locaStorageProvider";
import { useAppSelector } from "../../../Hooks";
import { getUserInfo } from "../../../store/user-process/selector";
import { AppRoute, LocalStorageMethod } from "../../../enums/enum";
import { getPersonalInfo, getUserLicAddresses } from "../../../store/integration-process/selector";

export default function ChangeLick() {
  const userInfo = useAppSelector(getUserInfo);
  const userLic = useAppSelector(getUserLicAddresses);
  let defaultLic = LocalStorageProvider(userInfo.userId, null, LocalStorageMethod.getItem);
  if (userInfo.lics?.length >= 1 && defaultLic == "") {
    LocalStorageProvider(userInfo.userId, { lic: userInfo.lics[0].lic, address: "" }, LocalStorageMethod.setItem);
    defaultLic = { lic: userInfo.lics[0].lic, address: "" };
  }
  // данные по счёту могут ещё не загрузиться (или не загрузиться вовсе) — адреса берём с запасом
  const currentAddress = useAppSelector(getPersonalInfo)?.address?.fullAddress;
  const addressOf = (lic: string) => userLic?.find((x) => x.lic == lic)?.fullAddress ?? (lic == defaultLic?.lic ? currentAddress : undefined) ?? "";
  const lics = (userInfo.lics ?? []).map((x) => x.lic);

  const select = (lic: string) => {
    if (lic == defaultLic?.lic) return;
    LocalStorageProvider(userInfo.userId, { lic, address: "" }, LocalStorageMethod.setItem);
    window.location.reload();
  };

  return (
    <>
      <List disablePadding sx={{ minWidth: { sm: 420 } }}>
        {lics.map((lic) => {
          const selected = lic == defaultLic?.lic;
          return (
            <ListItemButton key={lic} selected={selected} onClick={() => select(lic)} sx={{ mx: 0, mb: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                {selected ? <RadioButtonCheckedIcon color="primary" /> : <RadioButtonUncheckedIcon sx={{ color: "text.secondary" }} />}
              </ListItemIcon>
              <ListItemText primary={`Л/с ${lic}`} secondary={addressOf(lic) || " "} primaryTypographyProps={{ fontWeight: 600 }} />
            </ListItemButton>
          );
        })}
      </List>
      <Typography sx={{ mt: 1.5, fontSize: 14 }}>
        <Link to={AppRoute.Lic} style={{ color: "inherit" }}>
          Управление лицевыми счетами
        </Link>
      </Typography>
    </>
  );
}
